import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAbnormal, getAbnormalList} from '../../../apis/abnormal/abnormal'

const useQueryAbnormal = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getAbnormal(id),
        queryFn: async () => {
            const {data} = await getAbnormal(id)
            return {data}
        },
    })

    return {data, refetch}
}

export default useQueryAbnormal
